export default __webpack_public_path__ + "static/media/contacts-mail.a9938304.svg";